import { LayoutPropType } from '../../../types/layout';
import classNames from 'classnames';
import s from './CategoryListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { Typography } from 'ui-v2/components/Typography';

export const CategoryListing = ({ data }: LayoutPropType) => {
  // declaration
  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  return (
    <div className={s.root}>
      <div
        style={{
          gridTemplateColumns: `repeat( ${
            data?.metaData?.listingOrder?.[0] || data?.data?.length
          }, 1fr)`,
          background: `url(${data?.backgroundImage})`,
          objectFit: 'cover',
        }}
        className={s.container}
        onClick={(e) =>
          handleItemClickWithDelegation(
            e,
            CARDID,
            data?.entityType,
            data?.data,
            data?.title
          )
        }
      >
        {data?.data?.map((item, index) => (
          <div
            key={index}
            className={classNames('cmn_touchable_area', s.item)}
            id={CARDID}
            data-index={index}
          >
            <ShimmerImage
              src={item?.coverImage}
              className={s.image}
              loading="eager"
            />
            {item?.title && (
              <Typography
                label={item?.title}
                variant="body_3_medium"
                color="secondary"
                className={s.title}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
